(function ($) {
    var fn = ".part_ui_colors",
            $fn = $(fn);

    if ($fn.length) {

        $.fn.part_filter_add_labels = function () {
            var $el = $(this),
                    $label = $el.parent().attr("aria-label"),
                    $label_id = $el.attr("id"),
                    $color = $el.parent().data("color"),
                    $options = $el.closest(fn).find("[data-colors-selected]"),
                    $isOther = $el.data("id") === "other",
                    $style = (!$isOther) ? 'background-color: ' + $color + ';border-color: ' + $color + '' : '',
                    $product = $el.closest('[data-product]');

            $.fn.label_html = function () {
                var $this = $(this);

                function fn_grow_height() {
                    var wrapper = $el.closest(fn).find("[data-colors-selected]").parent(),
                            growDiv = $el.closest(fn).find("[data-colors-selected]");
                    wrapper.css("height", growDiv.outerHeight());
                }

                if ($el.is(':checked')) {
                    $this.append('<div class="col"><label style="' + $style + '" data-label-id="' + $label_id + '"><i class="icon icon--close"></i><i>' + $label + '</i></label></div>').find(".col:last-of-type").hide().fadeIn(300).addClass("mod--active");
                    fn_grow_height();
                    if ($isOther) {
                        $this.closest($fn).find("select").prop("disabled", false);
                    }
                } else if ($this.find("[data-label-id=" + $label_id + "]").length) {
                    $this.find("[data-label-id=" + $label_id + "]").parent().remove();
                    fn_grow_height();
                    if ($isOther) {
                        $this.closest($fn).find("select").prop("disabled", true);
                    }
                }
            };

            recountColors($product);
            $options.label_html();
        };

        if ($fn.find("[data-colors-selected]").length) {
            $fn.find(".wrp_colors_body").find("input").each(function () {
                $(this).part_filter_add_labels();
            });

            $doc.on("change", fn + " .wrp_colors_body input", function () {
                $(this).part_filter_add_labels();
            });

            $doc.on("click", fn + " [data-colors-selected] [data-label-id]", function () {
                var $el = $(this),
                        $id = $el.data("label-id"),
                        $content = $el.closest(fn).find(".wrp_colors_body");

                $content.find("#" + $id).prop("checked", false).trigger("change");
                $el.parent().remove();
            });
        }
    }
})(jQuery);